import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { deleteJob, getJobList } from "../../../redux/actions/JobActions"
import { CircularProgress } from '@material-ui/core';
// import darkblue from '../../../assets/images/bg/dark-blue.jpg';
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import moment from 'moment';
import 'moment/locale/fr';

let JobListing = (props) => {
    const { getJobList, deleteJob, storeJob = {} } = props;

    const [isLoading, setIsLoading] = React.useState(true);
    const [jobSearchResult, setJobSearchResult] = React.useState(null);
    const [displayingJobList, setDisplayingJobList] = React.useState([]);
    const [filterValues, setFilterValues] = React.useState([]);
    const [jobTodelete, setJobTodelete] = React.useState(null);
    const [jobsList, setJobsList] = React.useState([]);
    const [initialJobsList, setInitialJobsList] = React.useState([]);
    const [isDeletting, setIsDeletting] = React.useState(false);
    const closeDeleteJobsModal = React.useRef();

    useEffect(() => {
        if (jobsList.length == 0 && storeJob.jobList.length == 0) {
            getJobList(true).then(resp => {
                setJobsList(resp.jobsList);
                setInitialJobsList(resp.jobsList);
                setIsLoading(false);
            });
        }
        else if (jobsList.length == 0 && storeJob.jobList.length > 0) {
            setJobsList(storeJob.jobList);
            setInitialJobsList(storeJob.jobList);
            setIsLoading(false);
        }
        // window.scrollTo(0, 0)
    }, [])


    const checkboxHandleChange = (event) => {
        if (event.target.checked) {
            let filterValuesCopy = filterValues;
            filterValuesCopy.push(event.target.value);
            setFilterValues(filterValuesCopy)
            let documents = jobSearchResult.documents;
            let result = [];
            filterValues.forEach(element => {
                let jobs = documents.filter(doc => doc.category == element);
                if (jobs != null) {
                    result = result.concat(jobs);
                }
            });
            setDisplayingJobList(result);

        }
        else {
            let values = filterValues.filter(item => item != event.target.value);
            let documents = jobSearchResult.documents;
            let result = [];
            if (filterValues.length > 0) {
                filterValues.forEach(element => {
                    let jobs = documents.filter(doc => doc.category == element);
                    if (jobs != null) {
                        result = result.concat(jobs);
                    }
                });
            }
            else {
                result = documents;
            }
            setDisplayingJobList(result);
        }
    }

    const handleDeleteSubmit = () => {
        setIsDeletting(true);
        deleteJob(jobTodelete.id).then(resp => {
            setJobsList(resp.jobsList);
            setInitialJobsList(resp.jobList);
            setJobTodelete(undefined);
            closeDeleteJobsModal.current.click();
            setIsDeletting(false);
        });
    }

    const handleSearchBoxChange = (event) => {
        let searchTerm = event.target.value;
        let filteredData = initialJobsList.filter(value => {
            return (
                value.jobNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                value.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                value.employer?.companyName?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        });
        setJobsList(filteredData);
    }

    return (
        <React.Fragment>
            <Helmet>
                <title> Administration | Offres d'emploi  | Malibaara</title>
            </Helmet>
            {isLoading ? (
                <div className="row bg-white pt-4 mt-lg-0">
                    <div className="col-lg-12">
                        <div className="loading-container bg-white">
                            <CircularProgress />
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div className="row bg-white pt-4 mt-lg-0">
                        <div className="col-lg-12 mt-4 mt-lg-0">
                            <div className="row mb-4">
                                <div className="col-md-7 col-sm-5 d-flex align-items-center">
                                    <div className="section-title-02 mb-0 ">
                                        <h4 className="mb-0" style={{ marginLeft: "10px" }}>{jobsList?.length} offres d'emploi</h4>
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-7 mt-3 mt-sm-0">
                                    <div className="search">
                                        <i className="fas fa-search"></i>
                                        <input type="text" className="form-control" placeholder="Rechercher..." onChange={handleSearchBoxChange} />
                                    </div>
                                </div>
                            </div>
                            <table className="table table-striped" id="table"
                                data-toggle="table"
                                data-height="460"
                                data-pagination="true"
                                data-pagination-h-align="left"
                                data-pagination-detail-h-align="right">
                                <thead>
                                    <tr>
                                        <th scope="col" style={{ width: "10%" }}>Numéro</th>
                                        <th scope="col" style={{ width: "45%" }}>Titre</th>
                                        <th scope="col" style={{ width: "25%" }}>Employeur</th>
                                        <th scope="col" style={{ width: "15%" }}>Date</th>
                                        <th scope="col" style={{ width: "5%" }}>Statut</th>
                                        <th scope="col" style={{ width: "5%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobsList?.map((job, index) => (
                                        <tr key={index}>
                                            <td>
                                                {job.jobNumber}
                                            </td>
                                            <td>
                                                {job.title}
                                            </td>
                                            <td>
                                                {job?.employer?.companyName}
                                            </td>
                                            <td>
                                                {moment(job.postedDate).format('Do MMMM YYYY')}
                                            </td>
                                            <td>
                                                {job.isActive ? (<div className="active">Actif</div>) : (<div className="inactive">Inactif</div>)}
                                            </td>
                                            <td>
                                                <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                                    <li><Link to={"/admin/job/details/" + job.id}><i className="fas fa-pencil-alt"></i></Link></li>
                                                    <li><a href="assets/#" className="text-danger" data-toggle="modal" title="" data-target="#deleteJob" data-original-title="Delete">
                                                        <i className="far fa-trash-alt" onClick={() => setJobTodelete(job)}></i>
                                                    </a>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>


                    {/* Start Delete user modale */}
                    <div className="modal fade" id="deleteJob" tabIndex="-1" role="dialog" aria-modal="true">
                        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header p-4">
                                    <h4 className="mb-0 text-center">Suppression d'une offre d'emploi: {jobTodelete?.title}</h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <form className="mt-2">
                                    <div className="modal-body">
                                        <div>
                                            <div className="form-row">
                                                <p>Voulez vous supprimer cette offre?</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            data-dismiss="modal"
                                            className="btn btn-primary"
                                            ref={closeDeleteJobsModal}
                                        >
                                            NON
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={handleDeleteSubmit}
                                            disabled={isDeletting}
                                        >
                                            OUI &nbsp; {isDeletting ? <CircularProgress size={15} /> : <span></span>}
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                    {/* End Delete user modale */}
                </>
            )
            }
        </React.Fragment >
    );

}
JobListing.propTypes = {
    getJobList: PropTypes.func.isRequired,
    deleteJob: PropTypes.func.isRequired,
    storeJob: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    getJobList: PropTypes.func.isRequired,
    deleteJob: PropTypes.func.isRequired,
    storeJob: state.job,
});

// export default connect(mapStateToProps, { getJobList, deleteJob })(JobListing)
export default withRouter(connect(mapStateToProps, { getJobList, deleteJob })(JobListing));